import _mixin from '../_mixin'

export default {
  name: 'SActivityAddress',
  cnName: '活动-填写地址类',
  type: 'activity_common',
  preview: 'https://rescdn-crash.ssjj.cn/website/2023/03/30/dc3e42f445c1787417e8e090fd2b9591.jpeg',
  // 属性相关
  props: {
    activityId: 'ZHZTEJDNPJUGSO7W3SPOOLG6EY',
    defaultBg: {
      src: 'https://rescdn-crash.ssjj.cn/website/2025/03/13/26848eb593afba1634123fa194db14bb.jpg',
      style: {
        width: '1920px',
        height: '1542px'
      }
    },
    btnAddress: {
      src: 'https://rescdn-crash.ssjj.cn/website/2025/03/12/6cddc2f7d4bd42cf5b034ea4be3d09af.png',
      style: {
        width: '156px',
        height: '40px',
        position: 'absolute',
        top: '704px',
        right: '',
        bottom: '',
        left: '1110px'
      }
    }
  },
  propsDesc: [
    {
      target: 'activityId',
      label: '活动Id'
    },
    {
      target: 'defaultBg',
      label: '底图',
      formType: 'image'
    },
    {
      target: 'btnAddress',
      label: '规则按钮图片',
      formType: 'image'
    }
  ],

  // 样式相关
  styles: {
    ..._mixin.styles
  },
  stylesDesc: [
    ..._mixin.stylesDesc
  ],

  // 事件相关
  events: {
    // click: () => {} 无需配置
  },
  eventsList: [
    // eventTpl 无需配置
  ],
  eventsDesc: [
    ..._mixin.eventsDesc
  ],

  methods: [
    ..._mixin.methods
  ]
}
